var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-dropDownMenu"},[_c('van-dropdown-menu',{attrs:{"active-color":_vm.activeColor}},[_c('van-dropdown-item',{attrs:{"options":_vm.option1},on:{"change":_vm.change},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }